import { RefurbishedProductStateInterface } from "../../../common/interfaces/apiV2/shared/RefurbishedProductStateInterface";

export const canReserveProduct = (
    state: RefurbishedProductStateInterface,
): boolean => state.code.toLowerCase() === "online";
